import AMapLoader from '@amap/amap-jsapi-loader';
import { t } from '@b2c/services/decorator';

export class GDMap {
  static instance: any | null = null;
  map: any | null = null;
  driving: any | null = null;
  cityName = '';
  center: [number, number] = [0, 0];

  constructor() {}

  async load(options: any, cityName: string) {
    this.cityName = cityName;
    if (GDMap.instance) {
      return;
    }
    GDMap.instance = {};
    window['_AMapSecurityConfig'] = {
      serviceHost: `${window['AMapServiceHost']}/External/GaodeMapConfig/_AMapService`,
    };
    try {
      GDMap.instance = await AMapLoader.load({
        key: window['AMapKey'],
        version: '2.0',
        plugins: ['AMap.PlaceSearch', 'AMap.Driving'],
        ...options,
      });
    } catch (err) {
      console.error('高德地图加载失败', err);
      GDMap.instance = null;
    }
  }

  createMap(container: string, mapOptions?: object) {
    if (!GDMap.instance) {
      console.error('高德地图实例未加载');
      return null;
    }
    const center = mapOptions?.['center'] || [0.397428, 39.90923];
    this.center = center;
    const options = {
      viewMode: '2D', // 是否为2D地图模式
      zoom: 19, // 初始化地图级别
      showOversea: true, // 是否显示海外地图
      ...mapOptions,
      center, // 初始化地图中心点位置
    };
    const map = new GDMap.instance.Map(container, options);
    const driving = new GDMap.instance.Driving({
      map: map,
      panel: 'panel',
      autoFitView: true,
    });
    this.map = map;
    this.driving = driving;
  }
  destroyMap() {
    this.map?.destroy();
  }

  onClick(callback: (ev: any) => void) {
    this.map?.on('click', function (ev: any) {
      callback(ev);
    });
  }
  offClick(callback?: any) {
    this.map?.off('click', callback);
  }

  // 搜索POI ID
  getPOI_ID(keyword: string, city?: string) {
    return new Promise((resolve, reject) => {
      const placeSearch = new GDMap.instance.PlaceSearch({
        city: city || this.cityName,
      });
      placeSearch.search(keyword, function (status: string, result: any) {
        if (status === 'complete') {
          const poiId = result.poiList?.pois?.[0]?.id || '';
          resolve(poiId);
        } else {
          reject('查询失败：' + JSON.stringify(result));
        }
      });
    });
  }

  // 获取POI详情
  getDetails(poiId: string) {
    return new Promise((resolve, reject) => {
      const placeSearch = new GDMap.instance.PlaceSearch();
      placeSearch.getDetails(poiId, function (status: string, result: any) {
        if (status === 'complete') {
          resolve(result);
        } else {
          reject('查询失败：' + JSON.stringify(result));
        }
      });
    });
  }

  // 查附近
  searchNearBy(keyword: string, radius = 50000) {
    return new Promise((resolve, reject) => {
      const placeSearch = new GDMap.instance.PlaceSearch({
        type: keyword, // 兴趣点类别
        pageSize: 10, // 单页显示结果条数
        pageIndex: 1, // 页码
        city: this.cityName, // 兴趣点城市
        citylimit: true, //是否强制限制在设置的城市内搜索
      });
      placeSearch.searchNearBy(
        '',
        new GDMap.instance.LngLat(this.center[0], this.center[1]),
        radius,
        function (status: string, result: any) {
          // console.log('searchNearBy result', status, result);
          if (status === 'complete') {
            resolve(result);
          } else if (status === 'no_data') {
            resolve(undefined);
          } else {
            reject('查询失败：' + JSON.stringify(result));
          }
        }
      );
    });
  }

  // 路线规划
  routePlanning(target: [number, number]) {
    this.driving?.clear();
    // 根据起终点经纬度规划驾车导航路线
    return new Promise((resolve, reject) => {
      this.driving?.search(
        new GDMap.instance.LngLat(this.center[0], this.center[1]),
        new GDMap.instance.LngLat(...target),
        (status, result) => {
          if (status === 'complete') {
            resolve(result);
          } else {
            reject('获取驾车数据失败：' + JSON.stringify(result));
          }
        }
      );
    });
  }
}

// map.on('click', function (ev) {
//   //触发事件的对象
//   const target = ev.target;
//   //触发事件的地理坐标，AMap.LngLat 类型
//   const lnglat = ev.lnglat;
//   //触发事件的像素坐标，AMap.Pixel 类型
//   const pixel = ev.pixel;
//   //触发事件类型
//   const type = ev.type;

//   console.log('地图点击事件', ev);
// });

// // 查 POI ID
// const placeSearch1 = new GDMap.instance.PlaceSearch({
//   //city 指定搜索所在城市，支持传入格式有：城市名、citycode 和 adcode
//   city: '深圳',
// });
// placeSearch1.search(
//   '深圳天安云谷华为基地怡程酒店',
//   function (status, result) {
//     //查询成功时，result 即对应匹配的 POI 信息
//     console.log(result);
//   }
// );
// // 查详情
// const placeSearch = new GDMap.instance.PlaceSearch();
// const poiid = 'B0HB67N1AL';
// placeSearch.getDetails(poiid, function (status, result) {
//   //查询成功时，result 即为对应的 POI 详情
//   console.log(' poi 详情', result);
// });

// 查附近
// const placeSearch = new GDMap.instance.PlaceSearch({
//   type: '交通', // 兴趣点类别
//   pageSize: 5, // 单页显示结果条数
//   pageIndex: 1, // 页码
//   city: '深圳', // 兴趣点城市
//   citylimit: true, //是否强制限制在设置的城市内搜索
//   // map: map, // 展现结果的地图实例
//   // panel: 'panel', // 结果列表将在此容器中进行展示。
//   // autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
// });
// console.log('center', center);
// placeSearch.searchNearBy('', center, 50000, function (status, result) {
//   //查询成功时，result 即对应匹配的 POI 信息
//   console.log('result', result);
// });

// 驾车导航
